import { userInfo } from "os"
import { ActionType } from "../action-types/index"
import { Action } from "../actions"

export interface ReduxState {
    langValue: string,
    formData: any,
    freezScreen: boolean
    alert: any,
    shopUrl: any
    userInfo: any

}

const initialState = {
    notes: [],
    langValue: "en",
    formData: [],
    freezScreen: false,
    alert: {
        show: false,
        message: "",
    },
    shopUrl: "",
    userInfo: {}
}

const reducer = (state: ReduxState = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.SET_LANG_VALUE:
            return { ...state, langValue: action.payload }
        case ActionType.SET_FREEZ_SCREEN:
            return { ...state, freezScreen: action.payload }
        case ActionType.SET_FORMDATA:
            return { ...state, formData: action.payload }
        case ActionType.SET_ALERT_MESSAGE:
            return { ...state, alert: action.payload }
        case ActionType.SET_SHOP_URL:
            return { ...state, shopUrl: action.payload }
        case ActionType.SET_USER_INFO:
            return { ...state, userInfo: action.payload }

        default:
            return state
    }
}
export default reducer